import { useQuery } from '@tanstack/vue-query'
import { queries } from '~/keys/index'
import { DEFAULT_CACHE_TIME } from '~/constants'
import type { SuccessResponse } from '~/types/response'
import type { Language } from '~/types/common'

const useLanguages = () => {
  const { fetch } = useAPIFetch()

  return useQuery({
    ...queries.dictionaries.languages,
    queryFn: () =>
      fetch<SuccessResponse<Language[]>>({
        method: 'GET',
        url: 'languages',
      }),
    staleTime: DEFAULT_CACHE_TIME,
    select: data => data.data,
  })
}

export default useLanguages
